<nav class="bottom-nav" aria-label="Primary">
  <a *ngFor="let item of items" class="bottom-nav__item" [routerLink]="item.link" [queryParams]="item.queryParams"
    [class.is-active]="isActive(item)" [attr.aria-current]="isActive(item) ? 'page' : null">
    <i class="fa-solid" [ngClass]="item.icon" aria-hidden="true"></i>
    <span>{{ item.label }}</span>
  </a>
</nav>
